import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { nvlArr, nvlBool, nvlby, nvlNull, nvlObj } from 'src/app/core/services/utils.service'; 
import { LocalStorageHandler } from 'src/app/shared/services/local-storage';

@Injectable()
export class AuthGuard implements CanActivate {

  private localStorageHandler: LocalStorageHandler = new LocalStorageHandler();
  public pwdChangeRequired: boolean = true;

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this.authService.isLoggedIn.pipe(
      take(1),
      map((isLoggedIn: boolean) => {

        if (!isLoggedIn) {
          this.router.navigate(['/login']);
          return false;
        }

        const selectedUser: any = this.localStorageHandler.getUserOrganizationInformation();
        if (this.pwdChangeRequired && nvlBool(selectedUser.pwdChangeRequired) == 1) {
          this.pwdChangeRequired = false;
          this.router.navigate(['/pwd-change-required']);
          return false;
        }

        // this.isRouteAutorize(state, (isOk) => {
         
        //   if (isOk) {
        //     return true;
        //   } else {
        //     this.router.navigate(['/404']);
        //     return false;
        //   }
        // })

        this.pwdChangeRequired = true;
        return true;
      })
    )
  }

  public isRouteAutorize(state: any, callback: (result: boolean) => void) {

    // console.log(state.url);

    const url = nvlby(state.url, '');
    // alert(url)
    if (url == '/'
      || url == '/login'
      || url == '/home'
      || url == '/404'
      || url == '/pwd-change-required') {

      callback(true);

    } else {

      if (url.includes(';feature=')) {
        const featureNo = nvlNull(url.split(';feature=')[1]);
        if (featureNo) {
          this.authService.validateRoute(featureNo).subscribe(
            res => {
              callback(res.success)
            }
          )
        } else {
          callback(false);
        }
      } else {

        if (url.includes('/prescription/prescription-layout/')) {
          const featureNo = nvlNull(url.split('/')[3]);
          if (featureNo) {
            this.authService.validateRoute(featureNo).subscribe(
              res => {
                callback(res.success)
              }
            )
          } else {
            callback(false);
          }

        } else {
          callback(false);
        }
      }

    }

  }


  public routeValidation(stateUrl: any) {
    const localItem: any = localStorage.getItem("routeList");
    const routeList: any = nvlObj(JSON.parse(localItem)).routes;

    const url = nvlNull(stateUrl.split(';')[0]);
    const isOk = nvlArr(routeList).find((elm: any) => { return elm.routeUrl === url });
    if (isOk) {
      return true;
    }
    return false;
  }

}

